import React from 'react';

// Libs
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

// Components
import LayoutContent from './layoutContent';
import store from '../redux/store';

function Layout({ children }) {
  return (
    <div id='layout-gatsby'>
      <Provider store={store}>
        <LayoutContent>{children}</LayoutContent>
      </Provider>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
